module.exports = __webpack_public_path__ + "img/download.a7897433.svg";